const SubscApplyVehicleConst = {
  ITEM: {
    customerName: {
      title: '고객명',
      val: '',
      validate: false,
      disabled: false,
      func: {
        name: 'require'
      }
    },
    model: {
      title: '형식',
      val: '',
      validate: false,
      disabled: false,
      func: {
        name: 'require'
      }
    },
    modelYear: {
      title: '모델연도',
      val: '',
      validate: false,
      disabled: false,
      func: {
        name: 'digits',
        n: 4,
        comparison: '=',
      }
    },
    vehicleNumId: {
      title: '차대번호',
      val: '',
      validate: false,
      disabled: false,
      func: {
        name: 'digits',
        n: 17,
        comparison: '='
      }
    },
    vehicleRegDate: {
      title: '최초 등록일',
      val: '',
      validate: false,
      disabled: false,
      func: {
        name: 'date'
      }
    },
    vehicleRegNum: {
      title: '자동차 등록번호',
      val: '',
      validate: false,
      disabled: false,
      func: {
        name: 'numReg'
      }
    },
  },
};

export default SubscApplyVehicleConst;